export default [ '$stateProvider', $stateProvider => {
  $stateProvider
    .state('orderHistory', {
      url: '/booking-history',
      component: 'orderHistory'
    })
    .state('register', {
      url: '/register',
      component: 'register'
    })
    .state('editReservation', {
      url: '/manage-booking',
      component: 'editReservation'
    });
} ];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/user.routes.js